import $ from "jquery";

import "../scss/page.scss";

import "../scss/growth-blueprint.scss";
import "./scripts/slick/growth-blueprint.js";
import "./scripts/growth-blueprint/sign.js";